import { render, staticRenderFns } from "./V13PenguasaanFisik.vue?vue&type=template&id=76246abe&"
import script from "./V13PenguasaanFisik.vue?vue&type=script&lang=js&"
export * from "./V13PenguasaanFisik.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports